import { Wifi, WifiHigh, WifiOff } from 'lucide-react';
import React, { CSSProperties } from 'react';
import { theme } from 'styles/theme/theme';
import { ConnectionIndicatorState } from 'modules/overlay-v2/domain/utils/connection-quality-analyzer';
import useOverlayConnectionIndicator from 'modules/overlay-v2/ui/hooks/use-overlay-connection-indicator';

const SIZE = 32;

const COLOR: Record<Exclude<ConnectionIndicatorState, 'good'>, string> = {
  bad: theme.colors.DarkYellow,
  very_bad: theme.colors.error,
  lost: theme.colors.error,
  reconnecting: '#FF8C00', // Orange (DarkOrange)
};

const spinKeyframes = `
@keyframes overlay-wifi-spin {
  from { transform: rotate(0deg); }
  to   { transform: rotate(360deg); }
}
`;

const wrapperStyle: CSSProperties = {
  position: 'fixed',
  top: 8,
  left: 8,
  zIndex: theme.zIndex.toast,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
};

function OverlayConnectionIndicator() {
  const state = useOverlayConnectionIndicator();

  if (state === 'good') return null;

  const color = COLOR[state];

  const icon = (() => {
    switch (state) {
      case 'bad':
        return <Wifi size={SIZE} color={color} />;
      case 'very_bad':
        return <Wifi size={SIZE} color={color} />;
      case 'lost':
        return <WifiOff size={SIZE} color={color} />;
      case 'reconnecting':
        return <WifiHigh size={SIZE} color={color} />;
    }
  })();

  return (
    <>
      <style>{spinKeyframes}</style>
      <div style={wrapperStyle}>{icon}</div>
    </>
  );
}

export default OverlayConnectionIndicator;
